import {recordMapFilterOpen, setCurrentMapFilterCode, setCurrentPrimaryPaneOptionComponent} from "./commit_helpers";
import {primaryPaneOptionCollection} from "../../../primary_pane_option_collection";

export function selectPaneOption(sm, paneOptionComponent) {
    if (paneOptionComponent.hasMapFilter) {
        setCurrentMapFilterCode(sm, paneOptionComponent.mapFilterCode)
        recordMapFilterOpen(sm, paneOptionComponent.mapFilterCode)
    }

    if (paneOptionComponent.primaryPane) setCurrentPrimaryPaneOptionComponent(sm, paneOptionComponent.identifier);

    paneOptionComponent.trackOpened();
}

export function getPaneOptionComponentByIdentifier(identifier) {
    return primaryPaneOptionCollection.findByProp('identifier', identifier);
}

export function getCurrentPaneOptionComponent(sm) {
    return getPaneOptionComponentByIdentifier(sm.state['currentPrimaryPaneOptionComponentId']);
}